import React, { useState, useEffect, useCallback,useRef } from "react";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { CheckBox } from "devextreme-react/check-box";
import { Button } from "devextreme-react/button";
import SelectBox from "devextreme-react/select-box";
import DateBox from "devextreme-react/date-box";
import TextBox from "devextreme-react/text-box";
import NumberBox from "devextreme-react/number-box";
import { GetDatePartOnlyDiffFormat, handleDataGridExport } from "../../../common/Utils.js";
import { confirm } from "devextreme/ui/dialog";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
  Column,
  DataGrid,
  GroupPanel,
  Editing,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  ColumnChooser,
  ColumnChooserSearch,
  Toolbar,
  Item,
  Export,
  Pager,
  StateStoring
} from "devextreme-react/data-grid";

import { HubConnectionBuilder } from "@microsoft/signalr";
import Popup from 'devextreme-react/popup';
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
const SelectDryStratMainPage = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  const allowedPageSizes = [5, 10, 20, "all"];
  const [processCodes, setProcessCodes] = useState([
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
  ]);

  const [dryStratProcessCode, setDryStratProcessCode] = useState(processCodes[0]);
  const [seqNumber, setSeqNumber] = useState("");
  const [lblTotalBags, setlblTotalBags] = useState(0);
  const [lblTotalLbs, setLblTotalLbs] = useState(0);
  const [dryStratDate, setDryStratDate] = useState(new Date());
  const [dryStratArr, setDryStratArr] = useState([]);
  const [rowIdsToBeUpdated, setRowIdsToBeUpdated] = useState("");
  const [dryStratReport, setDryStartReprot] = React.useState(true);
  const [isGetReportPopupVisible, setIsGetReportPopupVisible] = React.useState(false);
  const [isReportInProgressPopupVisible, setIsReportInProgressPopupVisible] = React.useState(false);
  const [connection, setConnection] = React.useState(null);
  const [generatedReportFileName, setGeneratedReportFileName] = React.useState("");

  const UpdateDryStratOnClick = () => {
    UpdateDryStrat();
  };

  const UpdateDryStrat = () => {
    let result = confirm("<i>Process Records?</i>", "Pull Order");
    result.then((dialogResult) => {
      if (dialogResult) {
        dataGrid.current.instance().beginCustomLoading("Processing");
        var request = new Object();
        request.Selectdrylotsdate = dryStratDate;
        axios.post
          (
            `${window._env_.REACT_APP_APIS}/${routes.DryStratData.ProcessDryDateRecords}`, request,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            dataGrid.current.instance().endCustomLoading();
            dataGrid.current.instance().refresh();
            fetchDrySeqNumb();

              if (dryStratReport) 
              {
              var report = new Object();
              report.Name = "SOR0011";
              report.IgnoreFormat = true;
              var whereInfo = new Object();
              whereInfo.FieldType = 4; //ParameterTypeEnum.DateTime;
              whereInfo.FieldName = "SelectDryLotsDate";
              whereInfo.Operation = 3; //OperationEnum.Equal
              whereInfo.Origin = "SOMASTERDATABASE.SELECTDRYLOTSDATE";
              whereInfo.From = GetDatePartOnlyDiffFormat(dryStratDate, "/");
              report.FilterWhereInfoList = [];
              report.FilterWhereInfoList.push(whereInfo);

              axios.post
                (
                  `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
                  report,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      access_token: accessToken,
                    }
                  }
                )
                .then((res) => {
                  if (window._env_.Generate_Report_From_Remote) {
                    if (res.data.isSuccess) {
                      setIsGetReportPopupVisible(false);
                      setIsReportInProgressPopupVisible(true);
                    }
                    else {
                      alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                    }

                  }
                  else {
                    if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
                      if (res.data.isSuccess) {
                        window.open(`${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${res.data.fileName}`, '_blank');
                      }
                      else {
                        alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                      }
                    }
                    else {
                      alert("Cannot generate report", "Error");
                    }
                  }
                })
                .catch((err) => {
                  alert(err, "Error");
                });
            }
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });
      }
    });
  };

  useEffect(() => {
    fetchDrySeqNumb();
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  const fetchDrySeqNumb = () => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.DryStratData.GetSequenceNumber}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          }
        }
      )
      .then((res) => {
        setSeqNumber(res.data.seqno);
        setLblTotalLbs(res.data.totalseedissued);
        setlblTotalBags(res.data.totalbags);
      })
      .catch((err) => {
        console.log(err, "err in fetching Seq Number.");
      });
  };

  useEffect(() => {

    if (connection) {
      connection
        .start()
        .then((result) => {
          console.log("Connected!");

          connection.on("ReceiveMessage", (message) => {

            setGeneratedReportFileName(message.message);
            setIsGetReportPopupVisible(true);
            setIsReportInProgressPopupVisible(false);
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }, [connection]);

  const downloadReport = () => {

    var url = `${window._env_.REACT_APP_APIS}/${routes.reports.GetReportFile}?fileName=${generatedReportFileName}`;

    const link = document.createElement("a");
    link.href = url;
    link.download = generatedReportFileName;
    link.click();
  }

  const renderReportPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={closeGetReportPopup} className="report-btn">
          Close
        </Button>
        <Button onClick={downloadReport} className="report-btn ml-3">
          Download Report
        </Button>
      </div>
    )
  }

  const renderReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report generation is in progess ...</p>
        <Button onClick={closeReportInProgressPopup} className="report-btn">
          Close
        </Button>
      </div>
    )
  }

  const closeGetReportPopup = () => {
    setIsGetReportPopupVisible(false);
    setIsReportInProgressPopupVisible(false);
  }

  const closeReportInProgressPopup = () => {

    setIsReportInProgressPopupVisible(false);
  }
  const onSelectionChanged = ({ selectedRowKeys, selectedRowsData, currentSelectedRowKeys, currentDeselectedRowKeys }) => {
    var lbs = 0;
    var bags = 0;
    if (currentSelectedRowKeys.length > 0) {
      const filterObj = selectedRowsData.filter((e) => e.rowid == currentSelectedRowKeys[0]);
      if (filterObj && filterObj.length > 0) {
        filterObj[0].dryDateNumber = GetDatePartOnlyDiffFormat(dryStratDate, "/") + " - " + seqNumber;
        filterObj[0].processcode = dryStratProcessCode;
        const newArray = [...dryStratArr];
        let index = dryStratArr.findIndex(obj => obj.rowid === currentSelectedRowKeys[0]);
        newArray[index] = filterObj[0];
        setDryStratArr(newArray);
        lbs += filterObj[0].totalseedissued;
        bags += filterObj[0].totalbags;
      }
    }
    if (currentDeselectedRowKeys.length > 0) {
      let filterObj = dryStratArr.filter((e) => e.rowid == currentDeselectedRowKeys[0]);
      if (filterObj && filterObj.length > 0) {
        filterObj[0].dryDateNumber = '';
        filterObj[0].processcode = '';
        const newArray = [...dryStratArr];
        var index = dryStratArr.findIndex(obj => obj.rowid === currentDeselectedRowKeys[0]);
        newArray[index] = filterObj[0];
        setDryStratArr(newArray);
        lbs = 0;
        bags = 0;
      }
    }
    setlblTotalBags(bags);
    setLblTotalLbs(lbs);
  };
  const onDateValueChanged = (e) => {
    setDryStratDate(e.value);
  };
  function ClearSelection() {
    dataGrid.clearSelection();
  }
  function ClearDryDateNumberColumn() {
    var lbs = 0;
    var bags = 0;
    dryStratArr.forEach((obj1, i) => {
      const newArray = [...dryStratArr];
      const filterObj = newArray.filter((e) => e.rowid == obj1.rowid);
      if (filterObj.length > 0) {
        filterObj[0].dryDateNumber = "";
        var index = dryStratArr.findIndex((obj) => obj.rowid === obj1.rowid);
        newArray[index] = filterObj[0];
        setDryStratArr(newArray);
        setlblTotalBags(bags);
        setLblTotalLbs(lbs);
        setRowIdsToBeUpdated("");
      }
    });
  }
  const onValueChangedProcessCdSlctBx = (e) => {
    setDryStratProcessCode(e.value);
  }
  const onContentReady = (e) => {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", dataSource);
    }
  }

  const dataSource = createStore({
    key: 'rowid',
    loadUrl: `${window._env_.REACT_APP_APIS}/${routes.DryStratData.GetDryStratData}`,
    updateUrl: `${window._env_.REACT_APP_APIS}/${routes.DryStratData.UpdateDryDateRecordsFlags}`,
    onBeforeSend: function (method, ajaxOptions) {
      ajaxOptions.headers = {
        Authorization: `Bearer ${accessToken}`
      };
    }
  });
  const setDryStratChkbxVal = (newData, value, currentRowData) => {
    var rowIndex = dataGrid.current.instance().getRowIndexByKey(currentRowData.rowid);
    if (value) {
      dataGrid.current.instance().cellValue(rowIndex, "selectdrylotsdate", dryStratDate);
      dataGrid.current.instance().cellValue(rowIndex, "selectdrylotscode", dryStratProcessCode);
      dataGrid.current.instance().cellValue(rowIndex, "selectdrylotsnumber", seqNumber);
      var totalLbs = lblTotalLbs + ((currentRowData.totalseedissued == null || currentRowData.totalseedissued == undefined) ? 0 : currentRowData.totalseedissued);
      setLblTotalLbs(totalLbs);
      var totalBags = lblTotalBags + ((currentRowData.totalbags == null || currentRowData.totalbags == undefined) ? 0 : currentRowData.totalbags);
      setlblTotalBags(totalBags);

    }
    else {
      dataGrid.current.instance().cellValue(rowIndex, "selectdrylotsdate", "");
      dataGrid.current.instance().cellValue(rowIndex, "selectdrylotscode", "");
      dataGrid.current.instance().cellValue(rowIndex, "selectdrylotsnumber", "");
      var totalLbs = lblTotalLbs - ((currentRowData.totalseedissued == null || currentRowData.totalseedissued == undefined) ? 0 : currentRowData.totalseedissued);
      if (totalLbs < 0) {
        totalLbs = 0;
      }
      setLblTotalLbs(totalLbs);
      var totalBags = lblTotalBags - ((currentRowData.totalbags == null || currentRowData.totalbags == undefined) ? 0 : currentRowData.totalbags);
      if (totalBags < 0) {
        totalBags = 0;
      }
      setlblTotalBags(totalBags);
    }

    dataGrid.current.instance().saveEditData().then(() => {
    });
  }

  const chkbxIsInspect = (rowData, value) => {
    //this.defaultSetCellValue(rowData, value);

    var columns = dataGrid.current.instance().getVisibleColumns();
    var locationColumnIndex = dataGrid.current.instance().getVisibleColumnIndex("inspect");
    columns[locationColumnIndex].defaultSetCellValue(rowData, value);
  }

  const gridKey = "5784954e-7f13-438e-874f-7cd069868d3a";
   const [currentLayout, setCurrentLayout]= useState("Default");
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    


  return (
    <div style={{ backgroundColor: '#f0f1ef' }}>
      <h6 style={{ color: window._env_.Color2, marginTop: 0 }}>
      Select Dry Strat
      </h6>
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: '20px',
    }}
  >
    {/* Left Section - Title + Date + Process */}
    <div style={{ flex: '1', minWidth: '300px' }}>
      
      <div style={{ display: 'flex', marginTop: '0px', gap: '20px' }}>
        <div>
          <span>Date</span>
          <DateBox
            defaultValue={dryStratDate}
            min={new Date(2000, 12, 31)}
            max={new Date(2099, 12, 31)}
            type="date"
            onValueChanged={onDateValueChanged}
          />
        </div>
        <div>
          <span>Process Code</span>
          <SelectBox
            defaultValue={processCodes[0]}
            items={processCodes}
            onValueChanged={onValueChangedProcessCdSlctBx}
          />
        </div>
      </div>
    </div>

    {/* Middle Section - Sequence, Lbs, Bags */}
    <div
      style={{
        flex: '1',
        display: 'flex',
        gap: '20px',
        minWidth: '300px',
        marginTop: '0px',
      }}
    >
      <div>
        <span>Seq #</span>
        <TextBox value={seqNumber?.toString()} disabled={true} />
      </div>
      <div>
        <span>LBs</span>
        <NumberBox value={lblTotalLbs} format="#,##0.00" disabled={true} />
      </div>
      <div>
        <span>Bags</span>
        <NumberBox value={lblTotalBags} disabled={true} />
      </div>
    </div>

    {/* Right Section - Checkbox + Button */}
    <div
      style={{
        flex: '1',
        minWidth: '250px',
        marginTop: '0px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <CheckBox
        defaultValue={dryStratReport}
        onValueChange={(e) => setDryStartReprot(e.value)}
        text="Dry Lots Report"
      />

      <Button
        text="Process Order"
        type="default"
        onClick={UpdateDryStratOnClick}
        style={{ width: 'fit-content' }}
      />
    </div>
  </div>

      <section className="accordianLastRow">
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
          allowColumnReordering={true}
          allowColumnResizing={true}
          showBorders={true}
          className="WMReportGridStyle"
          hoverStateEnabled={true}
          searchEnabled={true}
          columnAutoWidth={true}
          onContentReady={onContentReady}
          ref={dataGrid}
        >
          <Export enabled={true} allowExportSelectedData={true} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <Sorting visible={false} />
          <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
          />
          <Editing
            mode="cell"
            refreshMode="reshape"
            allowUpdating={true}
            allowAdding={false}
            allowDeleting={false}
          />
          <FilterRow visible={false} />
          <FilterPanel visible={false} />
          <HeaderFilter enabled={true} visible={false} />
          <GroupPanel visible={false} />
          <Grouping autoExpandAll={false} />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={loadState}
            storageKey={gridKey}
            customSave={saveState}
          />
          <Column dataField="rowid" caption="Row Id" visible={false}></Column>
          <Column dataField="isselectdrylots" dataType="boolean" caption="" setCellValue={setDryStratChkbxVal} />
          <Column dataField="selectdrylotsdate" dataType="date" allowEditing={false} caption="Dry Date" ></Column>
          <Column dataField="selectdrylotsnumber" caption="Number" allowEditing={false}></Column>
          <Column dataField="selectdrylotscode" caption="" allowEditing={false}></Column>
          <Column dataField="wetstratoutdate" dataType="date" caption="Wet Out Date" allowEditing={false}></Column>
          <Column dataField="species" caption="Species" allowEditing={false}></Column>
          <Column dataField="iscut" dataType="boolean" caption="Cut" allowEditing={false}></Column>
          <Column dataField="inspect" dataType="boolean" caption="Inspect" setCellValue={chkbxIsInspect}></Column>
          <Column dataField="totalseedissued" caption="Qty" allowEditing={false}></Column>
          <Column dataField="prodlot" caption="Production Lot" allowEditing={false}></Column>
          <Column dataField="celltype" caption="Stock" allowEditing={false}></Column>
          <Column dataField="pullordernumber" caption="Charge" allowEditing={false}></Column>
          <Column dataField="facility" caption="Facility" allowEditing={false}></Column>

          <Toolbar>
          <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                 </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </section>
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Report!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isGetReportPopupVisible}
        contentRender={renderReportPopup}
      />
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Report!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isReportInProgressPopupVisible}
        contentRender={renderReportInProgressPopup}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(SelectDryStratMainPage);
